import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReservationServiceSelectors } from '../services/reservation-service/state/reservation-service.selectors';
import { RootState } from '../state/state';

@Injectable({
  providedIn: 'root',
})
export class InvoluntaryChangeGuard {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly router = inject(Router);

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    // Routes that load the reservation themselves can be landed on directly, e.g. after a page refresh
    if (next.data?.loadsOwnReservation) {
      return of(true);
    }
    return this.store.pipe(
      select(ReservationServiceSelectors.getRoutedReservation),
      map((reservation) => {
        if (reservation) {
          return true;
        }
        // No reservation in state (e.g. page refresh): send the user to a sibling route that loads it
        const redirectTo = next.data?.redirectOnMissingReservation;
        if (redirectTo) {
          const [path, query] = state.url.split('?');
          return this.router.parseUrl(`${path.substring(0, path.lastIndexOf('/') + 1)}${redirectTo}${query ? `?${query}` : ''}`);
        }
        return false;
      })
    );
  }
}
